import { CaseVoucherExportColumnSchema, depositExportFields, voucherExportFields, } from '@debbie/common/dist/economy/case-vouchers/export.js';
import { ExportType, ExportTypeSchema } from '@debbie/common/dist/index.js';
import { safeParse } from '@debbie/common/dist/util/json.js';
import z from 'zod/v4';
export const caseVoucherExportSettingsSchema = ExportTypeSchema.extend({
    markAsExported: z.boolean(),
    columns: z
        .array(CaseVoucherExportColumnSchema)
        .min(1)
        .max(100)
        .refine((columns) => new Set(columns.map(exportColumnKey)).size === columns.length),
});
export function exportColumnKey(column) {
    return column.type === 'field' ? column.field : column.propertyTypeId;
}
export const defaultExportSettings = (deposits) => ({
    exportType: ExportType.Csv,
    markAsExported: true,
    columns: (deposits ? depositExportFields : voucherExportFields).map((field) => ({ type: 'field', field })),
});
export const exportSettingsKey = (userId, tenantId, accountId) => `debbie.depositExport.v1.${userId}.${tenantId}.${accountId}`;
export const readExportSettings = (key, deposits) => {
    try {
        const raw = localStorage.getItem(key);
        if (raw != null) {
            const result = safeParse(raw, caseVoucherExportSettingsSchema);
            if (result.ok) {
                return result.data;
            }
        }
    }
    catch (error) {
        reportError(error);
    }
    return defaultExportSettings(deposits);
};
//# sourceMappingURL=export-settings.js.map